import { GradientText } from "lola-framework-ui-test";
import { useStore } from "../../store/globalState";
import { TransactionItem } from "./TransactionItem";
import type { ITransaction } from "../../interfaces/transactions";
import { useTranslation } from "react-i18next";
import { ScrollFadeIndicator } from "../ScrollFadeIndicator";


export interface TransactionsHistoryProps {
  items: unknown[];
}

export const TransactionsHistory: React.FC<TransactionsHistoryProps> = ({
  items = [],
}) => {
  const { t } = useTranslation("request");
  const { theme } = useStore();
  const { bodyCopy } = theme.whiteView;
  const isEmpty = items.length === 0;

  return (
    <>
      <GradientText className="normal-text transactions-history-title">
        {t("transactions.title")}
      </GradientText>
      <section className="transactions-history-container">
        <ScrollFadeIndicator color={bodyCopy} />
        {isEmpty ? (
          <section className="transactions-history-empty">
            <GradientText textColor={bodyCopy} className="empty-title">
              <b>{t("transactions.emptyTitle")}</b>
            </GradientText>
            <GradientText textColor={bodyCopy} className="empty-description">
              {t("transactions.emptyDescription")}
            </GradientText>
          </section>
        ) : (
          <section className="transactions-history-list">
            {items.map((transaction, index) => (
              <TransactionItem key={index} {...(transaction as ITransaction)} />
            ))}
          </section>
        )}
      </section>
    </>
  );
};
